/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Helper functions for dealing with legacy satisfiers that expect
 *               props to contain values from express instead of react-router
 */

import { convertQueryStringToParams } from '@zcode/utils'

// Convert the loadData props into the legacy satisfy props
export const createLegacyProps = (store, { history, location, match }) => ({
  dispatch: store.dispatch,
  history,
  location: {
    ...location,
    query: location.query ?? convertQueryStringToParams(location.search),
  },
  match,
  store,
})

// Approximate the express request object on the client
export const createExpressReq = (_, { history, location, match }) => ({
  // on the server, history will have (probably) a req prop
  // req is an express request object
  host: history.req
    ? history.req.host
    : typeof window !== 'undefined' && window.location && window.location.host,
  hostname: history.req
    ? history.req.hostname
    : typeof window !== 'undefined' && window.location && window.location.hostname,
  url: history.createHref(location),
  path: location.pathname,
  params: match.params,
})
